import userService from "../api/server/userService";
export const NAMESPACE = "userModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/userService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(userService)
};

const state = {
  users: [],
  loading: false,
  selectedUser: null
};
const actions = {
  async GET(context, data) {
    var api = await services.api;
    return api.getUsers().then(function(value) {
      context.commit("SET", value);
    });
  },
  async TOGGLE(context, data) {
    var api = await services.api;
    return api.toggleGroup(data.userId, data.groupId, data.toggleVal);
  },
  async DETAILS(context, data) {
    var api = await services.api;
    return api.getUserDetails(data).then(res => {
      context.commit("SET_DETAIL", res);
    });
  }
};
const mutations = {
  SET(storeState, data) {
    storeState.users = data;
  },
  SET_DETAIL(storeState, data) {
    storeState.selectedUser = data;
  }
};
const getters = {
  users: storeState => storeState.users,
  loading: storeState => storeState.loading,
  selectedUser: storeState => storeState.selectedUser
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
